import PropTypes from 'prop-types';
export const picturePropTypes = {
  /**
   * Picture src
   */
  src: PropTypes.string,
  /**
   * Picture alt
   */
  alt: PropTypes.string,
  /**
   * Image className
   */
  imgClassname: PropTypes.string
};